import { StyledEngineProvider, CssVarsProvider } from "@mui/joy/styles";
import EllipsisList from "./EllipsisList";
import { Box, Typography } from "@mui/material";
import "./index.css";
import { setTitle } from "../AppDrawer/store/AppDrawerSlicer";
import { useDispatch, useSelector } from "react-redux";
import { NotificationReducer } from "../../Slices";
import { useState } from "react";
import ClickAwayListener from '@mui/material/ClickAwayListener';

const NotificationDropDown = ({ onClickAway}) => {
  const [notificationArray, setNotificationData] = useState([
    {
      message: "Washing machine has t...",
      time: "6 hours",
      seen: false,
      img: "https://st.depositphotos.com/1024381/3351/i/950/depositphotos_33513995-stock-photo-teen-girl-beauty-face-happy.jpg",
    },
    {
      message: "Nice to Meet You please..",
      time: "6 hours",
      seen: false,
      img: "https://images.pond5.com/beautiful-face-young-girl-smiling-footage-029921817_iconl.jpeg",
    },
    {
      message: "Meeting at 8 pm",
      time: "6 hours",
      seen: false,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSi_q-7yOyYwNVxf3Xe-1u9sMtuNcDFuAKoWg&usqp=CAU",
    },
    {
      message: "Jacob has unlocked door",
      time: "6 hours",
      seen: false,
      img: "https://i1.sndcdn.com/artworks-CHVGbzIlRApGmEq6-zv0BBw-t500x500.jpg",
    },
    {
      message: "Good News ",
      time: "6 hours",
      seen: false,
      img: "https://images.pond5.com/beautiful-face-young-girl-smiling-footage-029921817_iconl.jpeg",
    },
  ]);
  const dispatch = useDispatch();
  const toggleNotification = useSelector(
    (state) => state.NotificationSlicer.data
  );
  const handleSideBarItemClick = () => {
    dispatch(setTitle("Notifications"));
    dispatch(NotificationReducer(!toggleNotification));
  };
  return (
    <ClickAwayListener onClickAway={onClickAway}>
    <Box className="Layout">
      <StyledEngineProvider injectFirst>
        <CssVarsProvider>
          {notificationArray.map((items, index) => {
            return (
              <div key={index}>
                <EllipsisList items={items} index={index} />
              </div>
            );
          })}
          <Box sx={{ height: "1px", backgroundColor: "#909090", mt: 2 }}></Box>

          <Typography
            onClick={handleSideBarItemClick}
            sx={{
              textAlign: "center",
              fontSize: "16px",
              color: "white",
              mt: 2,
              cursor: "pointer",
            }}
          >
            See All Notifications
          </Typography>
        </CssVarsProvider>
      </StyledEngineProvider>
    </Box>
    </ClickAwayListener> 
  );
};

export default NotificationDropDown;
